// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.my-masonry-grid {
  /* Not needed if autoprefixing */
  /* Not needed if autoprefixing */
  display: flex;
  margin-left: -30px;
  /* gutter size offset */
  width: auto;
}

.my-masonry-grid_column {
  padding-left: 15px;
  /* gutter size */
  background-clip: padding-box;
}

/* Style your items */
.my-masonry-grid_column > div {
  /* change div to reference your elements you put in <Masonry> */
  /* background: grey; */
  margin-bottom: 15px;
}

/* Testimonial */

.my-masonry-grid .testimonials_item img {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  overflow: hidden;
  object-fit: cover;
  object-position: top;
}

.my-masonry-grid .testimonials_item h2 span {
  color: var(--dPink);
}

.my-masonry-grid .testimonials_item p {
  position: relative;
  font-size: var(--pSize);
  font-weight: 400;
  padding: 20px 50px 0px;
}

.my-masonry-grid .testimonials_item .tst-1 {
  background: rgba(255, 241, 249, 0.6);
}

.my-masonry-grid .testimonials_item .tst-2 {
  background: rgb(195 197 248 / 20%);
}

.my-masonry-grid .testimonials_item .testimonials_item {
  padding: 80px 58px;
  position: relative;
}

.my-masonry-grid .testimonials_item img.quotation {
  position: absolute;
  left: 20px;
  top: 0px;
  mix-blend-mode: overlay;
  width: 27%;
  text-align: left;
  height: 100%;
}

.testimonial-page-item {
  padding: 20px 0;
  height: auto;
}

@media (max-width: 576px) {
  .my-masonry-grid .testimonials_item {
    padding: 20px 20px;
    position: relative;
  }

  .my-masonry-grid .testimonials_item p {
    padding: 0px 10px 0px;
  }

  .my-masonry-grid .testimonials_item h3 {
    margin-top: 20px;
  }
}

/* Testimonial End */

.my-masonry-grid .testimonials_item {
  background: #fff4fa;
  text-align: center;
}

.my-masonry-grid.tab2Data .testimonials_item {
  background: #f3f3fe;
}

.tab-list .active {
  /* background-color: none; */
}

.tab-list .testimonial_tab1,
.tab-list .active .testimonial_tab1 {
  background-color: #fff7fb;
  padding: 50px 20px;
  display: flex;
  align-items: center;
}

.tab-list .testimonial_tab2,
.tab-list .active .testimonial_tab2 {
  background-color: #f3f3fe;
  padding: 50px 20px;
  display: flex;
  align-items: center;
}

.tab-list .testimonial_tab1 p,
.tab-list .testimonial_tab2 p {
  font-weight: 600;
  margin-left: -20px;
}

.tab-list .testimonial_tab2 img,
.tab-list .testimonial_tab1 img {
  mix-blend-mode: overlay;
  width: 20%;
  margin-left: 32px;
}

.tab-list .active {
  /* background-color: initial; */
}

.testimonials_page_item.tab-list li {
  padding: 0px;
  width: 50%;
  margin: 0px;
  display: inline-block;
}
.testimonials_page_item.tab-list {
  display: block;
}
.testimonials_page_item.tab-list li:hover {
  cursor: pointer;
}
.testimonials_page_item.tab-list {
  margin-bottom: 50px;
  padding: 0px;
}
.tab-list .testimonial_tab1:hover {
  background: #f5e0ea;
}
.tab-list .testimonial_tab2:hover {
  background: #e3e3f7;
}
@media only screen and (min-width: 576px) and (max-width: 920px) {
  .tab-list .testimonial_tab2,
  .tab-list .active .testimonial_tab2 {
    padding: 50px 0px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/TestimonialPage.css"],"names":[],"mappings":"AAAA;EAEE,gCAAgC;EAEhC,gCAAgC;EAChC,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA,qBAAqB;AACrB;EACE,+DAA+D;EAC/D,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,gBAAgB;;AAEhB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,uBAAuB;EACvB,UAAU;EACV,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,oBAAoB;;AAEpB;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;EAEE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,uBAAuB;EACvB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE;;IAEE,iBAAiB;EACnB;AACF","sourcesContent":[".my-masonry-grid {\n  display: -webkit-box;\n  /* Not needed if autoprefixing */\n  display: -ms-flexbox;\n  /* Not needed if autoprefixing */\n  display: flex;\n  margin-left: -30px;\n  /* gutter size offset */\n  width: auto;\n}\n\n.my-masonry-grid_column {\n  padding-left: 15px;\n  /* gutter size */\n  background-clip: padding-box;\n}\n\n/* Style your items */\n.my-masonry-grid_column > div {\n  /* change div to reference your elements you put in <Masonry> */\n  /* background: grey; */\n  margin-bottom: 15px;\n}\n\n/* Testimonial */\n\n.my-masonry-grid .testimonials_item img {\n  width: 80px;\n  height: 80px;\n  border-radius: 50%;\n  overflow: hidden;\n  object-fit: cover;\n  object-position: top;\n}\n\n.my-masonry-grid .testimonials_item h2 span {\n  color: var(--dPink);\n}\n\n.my-masonry-grid .testimonials_item p {\n  position: relative;\n  font-size: var(--pSize);\n  font-weight: 400;\n  padding: 20px 50px 0px;\n}\n\n.my-masonry-grid .testimonials_item .tst-1 {\n  background: rgba(255, 241, 249, 0.6);\n}\n\n.my-masonry-grid .testimonials_item .tst-2 {\n  background: rgb(195 197 248 / 20%);\n}\n\n.my-masonry-grid .testimonials_item .testimonials_item {\n  padding: 80px 58px;\n  position: relative;\n}\n\n.my-masonry-grid .testimonials_item img.quotation {\n  position: absolute;\n  left: 20px;\n  top: 0px;\n  mix-blend-mode: overlay;\n  width: 27%;\n  text-align: left;\n  height: 100%;\n}\n\n.testimonial-page-item {\n  padding: 20px 0;\n  height: auto;\n}\n\n@media (max-width: 576px) {\n  .my-masonry-grid .testimonials_item {\n    padding: 20px 20px;\n    position: relative;\n  }\n\n  .my-masonry-grid .testimonials_item p {\n    padding: 0px 10px 0px;\n  }\n\n  .my-masonry-grid .testimonials_item h3 {\n    margin-top: 20px;\n  }\n}\n\n/* Testimonial End */\n\n.my-masonry-grid .testimonials_item {\n  background: #fff4fa;\n  text-align: center;\n}\n\n.my-masonry-grid.tab2Data .testimonials_item {\n  background: #f3f3fe;\n}\n\n.tab-list .active {\n  /* background-color: none; */\n}\n\n.tab-list .testimonial_tab1,\n.tab-list .active .testimonial_tab1 {\n  background-color: #fff7fb;\n  padding: 50px 20px;\n  display: flex;\n  align-items: center;\n}\n\n.tab-list .testimonial_tab2,\n.tab-list .active .testimonial_tab2 {\n  background-color: #f3f3fe;\n  padding: 50px 20px;\n  display: flex;\n  align-items: center;\n}\n\n.tab-list .testimonial_tab1 p,\n.tab-list .testimonial_tab2 p {\n  font-weight: 600;\n  margin-left: -20px;\n}\n\n.tab-list .testimonial_tab2 img,\n.tab-list .testimonial_tab1 img {\n  mix-blend-mode: overlay;\n  width: 20%;\n  margin-left: 32px;\n}\n\n.tab-list .active {\n  /* background-color: initial; */\n}\n\n.testimonials_page_item.tab-list li {\n  padding: 0px;\n  width: 50%;\n  margin: 0px;\n  display: inline-block;\n}\n.testimonials_page_item.tab-list {\n  display: block;\n}\n.testimonials_page_item.tab-list li:hover {\n  cursor: pointer;\n}\n.testimonials_page_item.tab-list {\n  margin-bottom: 50px;\n  padding: 0px;\n}\n.tab-list .testimonial_tab1:hover {\n  background: #f5e0ea;\n}\n.tab-list .testimonial_tab2:hover {\n  background: #e3e3f7;\n}\n@media only screen and (min-width: 576px) and (max-width: 920px) {\n  .tab-list .testimonial_tab2,\n  .tab-list .active .testimonial_tab2 {\n    padding: 50px 0px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
